/**
 * Vágólapra másolás — közös helper a miniappoknak.
 *
 * A navigator.clipboard CSAK biztonságos kontextusban (https / localhost) létezik: pl. a
 * mobilApp WebView-jában helyi (http) szerverről nincs. Ilyenkor, illetve ha a Clipboard API
 * elutasít (jogosultság, fókusz), a régi document.execCommand('copy') fallback fut egy
 * rejtett textarea-n (iOS-en is: setSelectionRange).
 *
 * A visszatérési érték KIZÁRÓLAG tényleges sikerre true — a hívó csak ekkor jelezhet
 * „Másolva”-t; false esetén érthető hibaüzenetet kell mutatnia.
 */
function execCommandCopy(text) {
    if (typeof document === 'undefined' || !document.body) {
        return false;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    try {
        ta.focus();
        ta.select();
        ta.setSelectionRange(0, text.length);
        return typeof document.execCommand === 'function' && document.execCommand('copy') === true;
    }
    catch (e) {
        return false;
    }
    finally {
        document.body.removeChild(ta);
    }
}
/**
 * A szöveg vágólapra másolása.
 *
 * @returns true, ha a másolás TÉNYLEGESEN sikerült
 */
export async function copyText(text) {
    if (!text) {
        return false;
    }
    const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
    if (clipboard && typeof clipboard.writeText === 'function') {
        try {
            await clipboard.writeText(text);
            return true;
        }
        catch (e) {
            // elutasítva (jogosultság / fókusz) -> a régi út
        }
    }
    return execCommandCopy(text);
}
